import {
  BlueconicAppDownloadModalProps,
  BlueconicCustomUrlModalProps,
  BlueconicDialogues,
  BlueconicLeadCaptureModalProps,
  BlueconicLeadCaptureModalSplitImgProps,
  BlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps,
  BlueconicLeadCaptureModalWithNewsletterProps,
  BlueconicLeadCaptureModalWithNewslettersProps,
  BlueconicNewsletterModalProps,
  BlueconicPaywallProps,
  BlueconicStickyBannerBottomProps,
} from './propInterfaces';

function isOptionalString(value: unknown): value is string | undefined {
  return typeof value === 'undefined' || typeof value === 'string';
}

export function isBlueconicCustomUrlModalProps(
  data: BlueconicCustomUrlModalProps
): data is BlueconicCustomUrlModalProps {
  return (
    typeof data.title === 'string' &&
    typeof data.subtitle === 'string' &&
    typeof data.disclosure === 'string' &&
    typeof data.customUrl === 'string' &&
    typeof data.buttonText === 'string' &&
    isOptionalString(data.highlight) &&
    data.dialogueType === BlueconicDialogues.CustomUrlModal
  );
}

export function isBlueconicAppDownloadModalProps(
  data: BlueconicAppDownloadModalProps
): data is BlueconicAppDownloadModalProps {
  return data.dialogueType === BlueconicDialogues.AppDownload;
}

export function isBlueconicNewsletterModalProps(
  data: BlueconicNewsletterModalProps
): data is BlueconicNewsletterModalProps {
  return (
    typeof data.newsletterName === 'string' &&
    typeof data.newsletterDescription === 'string' &&
    typeof data.frequency === 'string' &&
    typeof data.newsletterId === 'number' &&
    typeof data.authors === 'string' &&
    isOptionalString(data.redirectUri) &&
    isOptionalString(data.buttonText) &&
    typeof data.leadType === 'string' &&
    isOptionalString(data.highlight) &&
    data.dialogueType === BlueconicDialogues.NewsletterModal
  );
}

export function isBlueconicPaywallProps(
  data: BlueconicPaywallProps
): data is BlueconicPaywallProps {
  return (
    typeof data.title === 'string' &&
    isOptionalString(data.subtitle) &&
    typeof data.offerLink === 'string' &&
    isOptionalString(data.buttonText) &&
    isOptionalString(data.leadType) &&
    data.dialogueType === BlueconicDialogues.Paywall
  );
}

export function isBlueconicStickyBannerBottomProps(
  data: BlueconicStickyBannerBottomProps
): data is BlueconicStickyBannerBottomProps {
  return (
    typeof data.title === 'string' &&
    typeof data.buttonText === 'string' &&
    typeof data.redirectUri === 'string' &&
    typeof data.loggedInButtonText === 'string' &&
    typeof data.leadType === 'string' &&
    data.dialogueType === BlueconicDialogues.StickyBannerBottom
  );
}
export function isBlueconicLeadCaptureProps(
  data: BlueconicLeadCaptureModalProps
): data is BlueconicLeadCaptureModalProps {
  return (
    typeof data.title === 'string' &&
    typeof data.subtitle === 'string' &&
    isOptionalString(data.highlight) &&
    isOptionalString(data.disclosure) &&
    typeof data.leadType === 'string' &&
    typeof data.buttonText === 'string'
  );
}

export function isBlueconicSubscribeModalProps(
  data: BlueconicLeadCaptureModalSplitImgProps
): data is BlueconicLeadCaptureModalSplitImgProps {
  return (
    isOptionalString(data.highlight) &&
    typeof data.leadType === 'string' &&
    typeof data.buttonText === 'string' &&
    typeof data.offerCode === 'string' &&
    typeof data.imgPathLarge === 'string' &&
    typeof data.imgPathMedium === 'string' &&
    typeof data.imgPathSmall === 'string'
  );
}

export function isBlueconicLeadCaptureModalWithNewslettersProps(
  data: BlueconicLeadCaptureModalWithNewslettersProps
): data is BlueconicLeadCaptureModalWithNewslettersProps {
  return (
    Array.isArray(data.newsletterIds) &&
    typeof data.title === 'string' &&
    isOptionalString(data.subtitle) &&
    typeof data.buttonText === 'string' &&
    typeof data.leadType === 'string' &&
    typeof data.offerCode === 'string'
  );
}

export function isBlueconicLeadCaptureModalWithNewsletterProps(
  data: BlueconicLeadCaptureModalWithNewsletterProps
): data is BlueconicLeadCaptureModalWithNewsletterProps {
  return (
    typeof data.newsletterId === 'number' &&
    isOptionalString(data.subtitle) &&
    typeof data.buttonText === 'string' &&
    typeof data.leadType === 'string' &&
    typeof data.offerCode === 'string' &&
    isOptionalString(data.newsletterImageUrl)
  );
}

export function isBlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps(
  data: BlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps
): data is BlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps {
  return (
    typeof isOptionalString(data.highlight) &&
    typeof data.title === 'string' &&
    typeof data.subtitle === 'string' &&
    typeof data.buttonText === 'string' &&
    typeof data.leadType === 'string' &&
    typeof data.proOfferCode === 'string' &&
    typeof data.annualOfferCode == 'string'
  );
}
